import { render } from "./list-product.vue?vue&type=template&id=479e2dc4&scoped=true"
import script from "./list-product.vue?vue&type=script&lang=js"
export * from "./list-product.vue?vue&type=script&lang=js"

import "./list-product.vue?vue&type=style&index=0&id=479e2dc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479e2dc4"]])

export default __exports__